/*
 * @Author: liyxt
 * @Date: 2020-02-19 15:18:51
 * @LastEditors: liyxt
 * @LastEditTime: 2020-02-24 10:20:54
 * @Description: file content
 */
import React, { Component } from 'react';
import { ScrollElement, ScrollLink } from './scroll';

require('./index.less');

let timer = null;
class Anchor extends Component {
    constructor(props) {
        super(props);
        let arrLen = [].concat(...this.props.children);
        arrLen = arrLen.filter(e => e !== null);
        this.state = {
            arrLen, // 处理下没有children的情况  bbqin
            hover: false,
            currentIndex: 0,
        };
    }

    componentWillReceiveProps(nextProps) {
        // 改变传入的 children 
        let arrLen = [].concat(...nextProps.children);
        arrLen = arrLen.filter(e => e !== null);
        if ('children' in nextProps) {
            this.setState({ arrLen });
        }
    }

	hoverLouti = (flag, delay) => {
	    if (delay === true) {
	        timer = setTimeout(() => {
	            this.setState({ hover: flag });
	        }, 500);
	    } else {
	        clearTimeout(timer);
	        this.setState({ hover: flag });
	    }
		
	};
	
	render() {
	    let arrLength = this.state.arrLen.length;
	    return (
	        <div>
	            <div 
	                fieldid="stairs-area"
	                className={`${this.state.hover ? (arrLength >= 9 ? 'showborder-xl' : 'showborder') : ''}  lightapp-component-wrap`} 
	                onMouseLeave={this.hoverLouti.bind(this, false)} 
	                onMouseEnter={this.hoverLouti.bind(this, true)}
	                {...this.props}
	                style={{ display: this.state.hover ? 'block' : 'none' }}
	            >
	                <div ref={i => { this.i = i; }} className="component-affix-content" >
	                    {React.Children.map(this.state.arrLen, (ele, index) => {
	                        if (Number(arrLength) === Number(index + 1)) {
	                            return (
	                                <div>
	                                    <ScrollLink
	                                        to={ele.props.to}
	                                        spy={ele.props.spy}
	                                        containerId={ele.props.containerId}
	                                        smooth={ele.props.smooth}
	                                        duration={ele.props.duration}
	                                        offset={ele.props.offset}
	                                        onClick={() => {
	                                            this.i && [...this.i.children].forEach(item => {
	                                                item.children[0].classList.remove('active');
	                                            });
	                                            this.i && [...this.i.children][index].children[0].classList.add('active');
	                                            this.setState({ currentIndex: index }, () => {
	                                                ele.props.clickFun && ele.props.clickFun();   
	                                            });
	                                        }}
	                                        // className={ this.anchor_title_index(index) }
	                                    >
	                                        <div>
	                                            <span className="stairs-icon">
	                                                <div className="circle-center" />
	                                            </span>
	                                            <span className="stairs-title">
	                                                { ele && ele.props.children && ele.props.children.props.children}
	                                            </span>
	                                        </div>
	                                    </ScrollLink>
	                                </div>
	                            );
	                        } else {
	                            return (
	                                <div>
	                                    <ScrollLink
	                                        to={ele.props.to}
	                                        spy={ele.props.spy}
	                                        containerId={ele.props.containerId}
	                                        smooth={ele.props.smooth}
	                                        duration={ele.props.duration}
	                                        offset={ele.props.offset}
	                                        onClick={() => {
	                                            this.i && [...this.i.children].forEach(item => {
	                                                item.children[0].classList.remove('active');
	                                            });
	                                            this.i && [...this.i.children][index].children[0].classList.add('active');
	                                            this.setState({ currentIndex: index }, () => {
	                                                ele.props.clickFun && ele.props.clickFun();   
	                                            });
	                                        }}
	                                        // className={ this.anchor_title_index( index ) }
	                                    >
	                                        <div>
	                                            <span className="stairs-icon">
	                                                <div className="circle-center" />
	                                                <div className="vertical-line" />
	                                            </span>
	                                            <span className="stairs-title">
	                                                { ele && ele.props.children && ele.props.children.props.children}
	                                            </span>
	                                        </div>
	                                    </ScrollLink>
	                                </div>
	                            );
	                        }
	                    })}
	                </div>
	            </div>
	            <div
	                className='lightapp-component-affix-wrap'
	                onMouseLeave={this.hoverLouti.bind(this, false, true)} 
	                onMouseEnter={this.hoverLouti.bind(this, true)}
	            >
	                <div className="loutiTubiao-wrap">
	                    <span className="icon iconfont icon-loucengtubiao"/>
	                </div>
	            </div>
				
	        </div>
			
	    );
	}
}

Anchor.ScrollElement = ScrollElement;
Anchor.ScrollLink = ScrollLink;

export default Anchor;
